(function () {
    'use strict';

    angular
        .module('elogbooks.admin.site-associations')
        .controller('SiteAssociationsAuditTrailController', SiteAssociationsAuditTrailController);

    SiteAssociationsAuditTrailController.$inject = [
        'apiClient',
        'eventCollectionResponse',
        'messenger'
    ];

    function SiteAssociationsAuditTrailController(apiClient, eventCollectionResponse, messenger) {
        var vm = this;

        vm.eventCollectionResponse = eventCollectionResponse;
        vm.events = eventCollectionResponse && eventCollectionResponse.events ? eventCollectionResponse.events : [];
        vm.toggleEvent = toggleEvent;

        vm.events.forEach(function (event) {
            event.raisedBy = event._links && event._links.user ? event._links.user.title : 'Vantify Administration';
            event.metadata = event.metadata || {};
            event.hasItems = !!event.getLink('items');
        });

        function toggleEvent(event) {
            event.closed = !event.closed;

            if (event.closed && event.hasItems && !event.itemsLoaded && !event.itemsLoading) {
                loadEventItems(event, event.getLink('items'), { limit: 100, page: 1, datagroup: 'details' });
            }
        }

        function loadEventItems(event, link, params) {
            if (!link) {
                event.itemsLoaded = true;
                return;
            }

            event.itemsLoading = true;

            apiClient.get(link, params).then(function (response) {
                if (!response) {
                    event.itemsLoading = false;
                    messenger.error('REQUEST_ERROR');
                    return;
                }

                appendItems(event, response && response.items ? response.items : []);

                if (response && response.getLink('next')) {
                    loadEventItems(event, response.getLink('next'));
                    return;
                }

                event.itemsLoading = false;
                event.itemsLoaded = true;
            }).catch(function () {
                event.itemsLoading = false;
                messenger.error('REQUEST_ERROR');
            });
        }

        function appendItems(event, items) {
            items.forEach(function (item) {
                var changeType = item.changeType;

                event.metadata[changeType] = event.metadata[changeType] || [];
                event.metadata[changeType].push(item.metadata);
            });
        }
    }
})();
